/**
 * MSAL Configuration for Admin UnsOps
 * Multi-tenant authentication (same as ERP)
 */

import { Configuration, LogLevel } from '@azure/msal-browser';

// Multi-tenant authority (same as ERP)
const AUTHORITY = import.meta.env.VITE_AZURE_AUTHORITY || 'https://login.microsoftonline.com/organizations';

export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID || '',
    authority: AUTHORITY,
    redirectUri: import.meta.env.VITE_AZURE_REDIRECT_URI || window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
          case LogLevel.Info:
            console.info(message);
            break;
          case LogLevel.Verbose:
            console.debug(message);
            break;
        }
      },
      logLevel: import.meta.env.DEV ? LogLevel.Info : LogLevel.Error,
    },
  },
};

// Scopes for login (basic profile info)
export const loginRequest = {
  scopes: ['openid', 'profile', 'email'],
};

// Scopes for API access
export const apiRequest = {
  scopes: ['api://erp.uns-ops.tech/access_as_user'],
};

// API URL
export const apiConfig = {
  baseUrl: import.meta.env.VITE_API_URL || 'https://hassapollo.azurewebsites.net',
  graphqlEndpoint: '/gql',
};
